import { baseApiService, type QueryParams } from './base'
import type { ReportsResponse } from './types'

// Types specific to reports API
export type ReportTypesMapResponse = Record<string, string>
export type TaskTypesMapResponse = Record<string, string>

// Overview default reports (used on dashboard)
export async function getReports(): Promise<ReportsResponse> {
  return baseApiService.fetch<ReportsResponse>('/api/reports', {
    params: {
      pageSize: 5,
      pageStart: 0,
      showObsoleted: false,
      sortBy: 'updatedAt',
      sortDesc: true
    }
  })
}

// Full reports list with filters matching legacy Angular behavior
export async function getReportsList(
  systemDocumentType?: string | null,
  systemFolderReportType?: string | null,
  filter: QueryParams = {}
): Promise<ReportsResponse> {
  const params: QueryParams = {
    // When folder report type is provided, Angular passed null for systemDocumentsType
    systemDocumentsType: systemFolderReportType ? null : systemDocumentType,
    systemFolderReportType: systemFolderReportType ?? null,
    ...filter
  }

  return baseApiService.fetch<ReportsResponse>('/api/reports', { params })
}

// Count endpoint expects POST with same merged payload
export async function getReportsCount(
  systemDocumentType?: string | null,
  systemFolderReportType?: string | null,
  filter: Record<string, unknown> = {}
): Promise<number> {
  const body = {
    systemDocumentsType: systemFolderReportType ? null : systemDocumentType,
    systemFolderReportType: systemFolderReportType ?? null,
    ...filter
  }

  return baseApiService.fetch<number>('/api/reports/countall', {
    method: 'POST',
    body
  })
}

export async function getReportTypesMap(systemDocumentType?: string): Promise<ReportTypesMapResponse> {
  return baseApiService.fetch<ReportTypesMapResponse>('/api/reports/reporttypesmap', {
    params: { type: systemDocumentType }
  })
}

export async function getTaskTypesMap(): Promise<TaskTypesMapResponse> {
  return baseApiService.fetch<TaskTypesMapResponse>('/api/reports/taskreporttasktypesmap')
}

// React-style count endpoint that accepts assembled filter directly (matches legacy behavior)
export async function getReportsCountReact(filter?: Record<string, unknown>): Promise<number> {
  return baseApiService.fetch<number>('/api/reports/countall', {
    method: 'POST',
    body: filter
  })
}
